<!-- 新闻列表项组件 -->
<template>
    <div class="articleitem-wrap" :id="'articleitem-'+articleItem.id">
        <div class="article-item">
            <div class="title-group">                
                <div class="icon"></div>
                <div class="title">
                    <router-link :to="articleItem.video!=null ? `/player?id=${articleItem.id}` : `/article?id=${articleItem.id}`" tag="a" target="_blank">{{articleItem.title}}</router-link>
                </div>
            </div>
            <div class="date">
                <span>{{ parseTime(articleItem.publishDate, "{yyyy}-{mm}-{dd}") }}</span>
            </div>
        </div>
    </div>
</template>
<script>

    export default{
        name:"ArticleListItem",
        components: {},
        props:{
            articleItem:{
                type:Object,
                default: ()=>({}),
            }
        },
        data(){
            return {};
        },
        methods:{

        },
        created(){},
        mounted(){},
    };
</script>
<style scoped>
    .articleitem-wrap{
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0px 20px;
      align-self: stretch;
      background: #FFFFFF;
      box-sizing: border-box;
      border-width: 0px 0px 1px 0px;
      border-style: solid;
      border-color: #E8DBD4;
    }
    .articleitem-wrap:hover{
        background-color: #f9f9f9;
    }

    .article-item{
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 30px 20px;
        align-self: stretch;
    }

    .article-item .title-group{
        display: -webkit-box;
        padding: 0px;
        
    }

    .title-group .icon{
        background: url('~@/assets/icons/svg/news-paper-text.svg') no-repeat;
        background-size: cover;
        flex: 0 0 24px;
        height: 24px;
        width: 24px;
    }

    .article-item .title{
        font-size: 20px;
        font-weight: normal;
        line-height: 24px;
        letter-spacing: 0em;
        color: #000000;
        margin-left: 12px;
    }

    .article-item .date{
        font-size: 14px;
        font-weight: normal;
        line-height: 14px;
        letter-spacing: 0em;
        color: #9E9E9E;

    }

    @media (max-width: 600px) {
        .article-item{
            padding: 12px 0px 12px 0px;
            flex-direction: column;
            align-items: start !important;
        }
        .article-item .title{
            font-size: 16px;
        }
        .article-item .title-group{
            display: -webkit-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            flex-direction: row;
            width: 100%;
        }
        .article-item .date{
            margin-top: 12px;
        }
    }


</style>



// WEBPACK FOOTER //
// src/components/memorychannel/articlelist/articlelistitem.vue